module.exports = __webpack_public_path__ + "static/media/logo_ministry.85c80fd5.png";